import Vue from 'vue';

// 返利模式
Vue.filter('rebateModeFilter', function (value) {
  return value === 'M' ? '固定金额' : '固定比例';
});

// 返利价格
Vue.filter('rebatePriceFilter', function (value, price) {
  return value === 'M' ? price : price + '%';
});